import PersonalityQuizBasicModel from "./PersonalityQuizBasicModel";
import PersonalityQuizQuestionModel from "./PersonalityQuizQuestionModel";
import PersonalityQuizPersonaResultsModel from "./PersonalityQuizPersonaResultsModel";

export default class PersonalityQuizFullModel extends PersonalityQuizBasicModel {
  public rules: string | null = null;
  public questions: PersonalityQuizQuestionModel[] = [];
  public personaResults: PersonalityQuizPersonaResultsModel[] = [];
}
